/* Sanctum Vials — theme.js
   Wires up the static Sanctum UI to Shopify's cart AJAX + section rendering APIs.

   No build step. Plain ES2020+. Loaded at the end of <body> in theme.liquid. */

(function () {
  'use strict';

  const $  = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => Array.from(el.querySelectorAll(sel));

  const theme = window.theme || {};
  const routes = theme.routes || {};

  /* ---------- Toast ---------- */
  const toastRoot = $('#ToastRoot');
  let toastTimer;
  function notify(message, opts = {}) {
    if (!toastRoot) return;
    toastRoot.innerHTML = '';
    const pill = document.createElement('div');
    pill.style.cssText =
      'position:fixed;bottom:32px;left:50%;transform:translateX(-50%);' +
      'background:rgba(20,20,20,0.92);backdrop-filter:blur(14px);' +
      'border:1px solid var(--border-strong);padding:12px 18px;border-radius:999px;' +
      'font-size:13px;color:#5dc593;display:flex;align-items:center;gap:10px;' +
      'z-index:200;box-shadow:0 20px 40px rgba(0,0,0,0.6);animation:pageIn .3s ease both;';
    pill.innerHTML =
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l4 4 10-10"/></svg>' +
      '<span></span>';
    pill.querySelector('span').textContent = message;
    if (opts.action) {
      const btn = document.createElement('button');
      btn.textContent = opts.action.label;
      btn.style.cssText =
        'margin-left:12px;padding:4px 10px;background:rgba(31,138,91,0.15);' +
        'border:1px solid rgba(31,138,91,0.3);border-radius:999px;font-size:11px;color:#5dc593;' +
        'font-family:var(--mono);letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;';
      btn.addEventListener('click', () => { opts.action.onClick(); pill.remove(); });
      pill.appendChild(btn);
    }
    toastRoot.appendChild(pill);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => pill.remove(), opts.duration || 2600);
  }
  window.notify = notify;

  /* ---------- Header scroll state ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Generic drawer/modal helpers ---------- */
  function openOverlay(el, scrim) {
    if (!el) return;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeOverlay(el, scrim) {
    if (!el) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('open');
    if (!$('.drawer.open, .mobile-drawer.open, .search-modal.open, .account-modal.open')) {
      document.body.classList.remove('no-scroll');
    }
  }

  /* ---------- Mobile drawer ---------- */
  const mobileDrawer = $('[data-mobile-drawer]');
  const mobileScrim  = $('[data-mobile-scrim]');
  $$('[data-open-mobile]').forEach(b => b.addEventListener('click', () => openOverlay(mobileDrawer, mobileScrim)));
  $$('[data-close-mobile]').forEach(b => b.addEventListener('click', () => closeOverlay(mobileDrawer, mobileScrim)));
  if (mobileScrim) mobileScrim.addEventListener('click', () => closeOverlay(mobileDrawer, mobileScrim));

  /* ---------- Search modal ---------- */
  const searchModal = $('[data-search-modal]');
  const searchScrim = $('[data-search-scrim]');
  const searchInput = $('[data-search-input]');
  const searchEmpty = $('[data-search-empty]');
  const searchResults = $('[data-search-results]');
  const searchNone = $('[data-search-noresults]');
  let searchTimer;

  function openSearch() {
    openOverlay(searchModal, searchScrim);
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }
  function closeSearch() { closeOverlay(searchModal, searchScrim); }
  $$('[data-open-search]').forEach(b => b.addEventListener('click', openSearch));
  if (searchScrim) searchScrim.addEventListener('click', closeSearch);

  $$('[data-search-chip]').forEach(b => b.addEventListener('click', () => {
    if (searchInput) { searchInput.value = b.getAttribute('data-search-chip'); searchInput.dispatchEvent(new Event('input')); }
  }));

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (!q) {
        if (searchEmpty)   searchEmpty.hidden = false;
        if (searchResults) { searchResults.hidden = true; searchResults.innerHTML = ''; }
        if (searchNone)    searchNone.hidden = true;
        return;
      }
      searchTimer = setTimeout(() => runPredictiveSearch(q), 180);
    });
  }

  async function runPredictiveSearch(q) {
    if (!routes.predictive_search_url) return;
    try {
      const url = routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=6';
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (searchEmpty)   searchEmpty.hidden = true;
      if (products.length === 0) {
        if (searchResults) { searchResults.hidden = true; searchResults.innerHTML = ''; }
        if (searchNone) { searchNone.hidden = false; searchNone.textContent = 'No matches for "' + q + '"'; }
        return;
      }
      if (searchNone) searchNone.hidden = true;
      if (searchResults) {
        searchResults.hidden = false;
        searchResults.innerHTML = products.map(p => {
          const img = p.featured_image ? p.featured_image.url : '';
          const price = (p.price !== undefined) ? formatMoney(p.price) : '';
          return (
            '<a class="search-result" href="' + p.url + '">' +
              '<div class="search-result-thumb">' +
                (img ? '<img src="' + img + '&width=128" alt="" style="max-width:48px;max-height:60px;object-fit:contain">' : '') +
              '</div>' +
              '<div>' +
                '<div class="search-result-name">' + escapeHtml(p.title) + '</div>' +
                '<div class="search-result-sub">' + (p.vendor ? escapeHtml(p.vendor) + ' · ' : '') + price + '</div>' +
              '</div>' +
              '<span style="color:var(--muted);margin-left:auto">' +
                '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
              '</span>' +
            '</a>'
          );
        }).join('');
      }
    } catch (e) { console.warn('search failed', e); }
  }

  /* ---------- Account modal ---------- */
  const accountModal = $('[data-account-modal]');
  const accountScrim = $('[data-account-scrim]');
  const accountSwitch = $('[data-account-switch]');
  const accountHeading = $('[data-account-heading]');
  const accountSub = $('[data-account-sub]');
  const accountSubmit = $('[data-account-submit]');
  const accountSwitchText = $('[data-account-switch-text]');
  const accountInstitution = $('[data-signup-only]');
  let accountMode = 'signin';

  function applyAccountMode() {
    if (!accountHeading) return;
    if (accountMode === 'signin') {
      accountHeading.textContent = 'Welcome back.';
      accountSub.textContent = 'Sign in to view orders, COAs and saved compounds.';
      accountSubmit.textContent = 'Send sign-in link';
      accountSwitchText.textContent = 'New to Sanctum?';
      if (accountSwitch) accountSwitch.textContent = 'Create an account';
      if (accountInstitution) { accountInstitution.hidden = true; accountInstitution.required = false; }
    } else {
      accountHeading.textContent = 'Create an account.';
      accountSub.textContent = 'Track orders and access lot archives.';
      accountSubmit.textContent = 'Create account';
      accountSwitchText.textContent = 'Already have an account?';
      if (accountSwitch) accountSwitch.textContent = 'Sign in';
      if (accountInstitution) { accountInstitution.hidden = false; accountInstitution.required = true; }
    }
  }
  if (accountSwitch) accountSwitch.addEventListener('click', () => {
    accountMode = (accountMode === 'signin') ? 'signup' : 'signin';
    applyAccountMode();
  });

  $$('[data-open-account]').forEach(b => {
    // If customer accounts are enabled (a real /account URL exists), let the
    // link navigate normally. Otherwise open the modal as a placeholder.
    b.addEventListener('click', (e) => {
      if (b.tagName === 'A' && b.getAttribute('href') && b.getAttribute('href') !== '#') return;
      e.preventDefault();
      openOverlay(accountModal, accountScrim);
    });
  });
  $$('[data-close-account]').forEach(b => b.addEventListener('click', () => closeOverlay(accountModal, accountScrim)));
  if (accountScrim) accountScrim.addEventListener('click', () => closeOverlay(accountModal, accountScrim));

  /* ---------- Escape closes any open overlay ---------- */
  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeOverlay(mobileDrawer, mobileScrim);
    closeOverlay(searchModal, searchScrim);
    closeOverlay(accountModal, accountScrim);
    closeCart();
  });

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartScrim  = $('[data-cart-scrim]');
  const cartBody   = $('[data-cart-body]');
  const cartSummary = $('[data-cart-summary]');
  const cartCountEl = $('[data-cart-count]');

  function openCart() { openOverlay(cartDrawer, cartScrim); }
  function closeCart() { closeOverlay(cartDrawer, cartScrim); }
  $$('[data-open-cart]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  $$('[data-close-cart]').forEach(b => b.addEventListener('click', closeCart));
  if (cartScrim) cartScrim.addEventListener('click', closeCart);

  async function refreshCart() {
    if (!cartDrawer) return;
    try {
      // Re-fetch the cart-drawer section markup
      const res = await fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        const newBody = tmp.querySelector('[data-cart-body]');
        const newSummary = tmp.querySelector('[data-cart-summary]');
        if (cartBody && newBody) cartBody.innerHTML = newBody.innerHTML;
        if (cartSummary && newSummary) cartSummary.innerHTML = newSummary.innerHTML;
      }
      // Update count badge
      const cartRes = await fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      const cart = await cartRes.json();
      if (cartCountEl) {
        cartCountEl.textContent = cart.item_count;
        cartCountEl.hidden = cart.item_count === 0;
      }
    } catch (e) { console.warn('refreshCart failed', e); }
  }

  async function cartAdd(variantId, quantity) {
    const res = await fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    return res.json();
  }
  async function cartChange(line, quantity) {
    const res = await fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line, quantity: Number(quantity) })
    });
    return res.json();
  }

  // Add-to-cart from product cards
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    try {
      const result = await cartAdd(variantId, 1);
      await refreshCart();
      const item = (result.items && result.items[0]) || result;
      notify((item.product_title || item.title || 'Item') + ' ' + theme.strings.addedToCart,
        { action: { label: theme.strings.viewCart, onClick: openCart } });
    } catch (err) {
      notify(err.message || 'Could not add to cart');
    } finally { btn.disabled = false; }
  });

  // Cart line qty +/- and remove (delegated)
  document.addEventListener('click', async (e) => {
    const line = e.target.closest('[data-line-key]');
    if (!line) return;
    const key = line.getAttribute('data-line-key');
    const qtyEl = line.querySelector('[data-qty]');
    const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

    if (e.target.closest('[data-qty-increase]')) {
      e.preventDefault();
      await cartChange(key, currentQty + 1);
      await refreshCart();
    } else if (e.target.closest('[data-qty-decrease]')) {
      e.preventDefault();
      await cartChange(key, Math.max(0, currentQty - 1));
      await refreshCart();
    } else if (e.target.closest('[data-line-remove]')) {
      e.preventDefault();
      await cartChange(key, 0);
      await refreshCart();
    }
  });

  /* ---------- Product page interactivity ---------- */
  // Quantity buttons
  const pdpQtyInput = $('[data-pdp-qty]');
  const pdpDec = $('[data-pdp-qty-decrease]');
  const pdpInc = $('[data-pdp-qty-increase]');
  const pdpTotal = $('[data-pdp-total]');
  const pdpPrice = $('[data-price]');
  const pdpVariantInput = $('[data-variant-id]');
  const pdpUnitPriceInput = $('[data-unit-price-cents]');
  let pdpUnitPriceCents = pdpUnitPriceInput
    ? (parseInt(pdpUnitPriceInput.getAttribute('value'), 10) || 0)
    : (pdpPrice ? parsePriceCentsFromText(pdpPrice.textContent) : 0);
  function updatePdpTotal() {
    if (!pdpTotal || !pdpQtyInput) return;
    const q = parseInt(pdpQtyInput.value, 10) || 1;
    pdpTotal.textContent = formatMoney(pdpUnitPriceCents * q);
  }
  if (pdpDec) pdpDec.addEventListener('click', () => {
    pdpQtyInput.value = Math.max(1, (parseInt(pdpQtyInput.value, 10) || 1) - 1); updatePdpTotal();
  });
  if (pdpInc) pdpInc.addEventListener('click', () => {
    pdpQtyInput.value = (parseInt(pdpQtyInput.value, 10) || 1) + 1; updatePdpTotal();
  });
  if (pdpQtyInput) pdpQtyInput.addEventListener('input', updatePdpTotal);

  // Variant selector
  $$('[data-variant-select]').forEach(b => b.addEventListener('click', () => {
    const id = b.getAttribute('data-variant-select');
    const priceCents = parseInt(b.getAttribute('data-variant-price'), 10) || pdpUnitPriceCents;
    pdpUnitPriceCents = priceCents;
    if (pdpVariantInput) pdpVariantInput.value = id;
    if (pdpPrice) pdpPrice.textContent = formatMoney(priceCents);
    updatePdpTotal();
    $$('[data-variant-select]').forEach(x => x.classList.remove('emerald'));
    b.classList.add('emerald');
    // Reflect in URL so deep-linking works
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
    } catch (_) {}
  }));

  // Product form submit → AJAX add (intercepts standard submit)
  const productForm = $('#ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      // Allow the dynamic checkout button (Shop Pay etc.) to use its own native submit path.
      if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
      e.preventDefault();
      const fd = new FormData(productForm);
      try {
        const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        if (!res.ok) throw new Error('Could not add to cart');
        await refreshCart();
        notify(($('h1') && $('h1').textContent.trim()) + ' ' + theme.strings.addedToCart,
          { action: { label: theme.strings.viewCart, onClick: openCart } });
      } catch (err) { notify(err.message || 'Add to cart failed'); }
    });
  }

  // Tabs
  $$('[data-tabs]').forEach(group => {
    const tabs = $$('[data-tab]', group);
    const panels = $$('[data-tab-panel]', group);
    tabs.forEach(t => t.addEventListener('click', () => {
      const target = t.getAttribute('data-tab');
      tabs.forEach(x => { x.classList.toggle('active', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      panels.forEach(p => { p.hidden = p.getAttribute('data-tab-panel') !== target; });
    }));
  });

  // Thumbnail swap (PDP gallery)
  $$('[data-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
    const url = thumb.getAttribute('data-thumb');
    const gallery = thumb.closest('.product-page-grid').querySelector('.product-gallery-inner img');
    if (gallery && url) {
      // Use the full-res URL but let the browser swap src
      gallery.setAttribute('src', url);
    }
    $$('[data-thumb]').forEach(x => x.classList.remove('active'));
    thumb.classList.add('active');
  }));

  /* ---------- Accordions ---------- */
  $$('[data-acc-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const item = btn.closest('.acc-item');
    if (!item) return;
    const wasOpen = item.classList.contains('open');
    item.parentElement.querySelectorAll('.acc-item.open').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  }));

  /* ---------- Filter panel toggles (collection page) ---------- */
  const filterToggle = $('[data-filter-toggle]');
  const filterSide   = $('[data-filter-side]');
  if (filterToggle && filterSide) {
    filterToggle.addEventListener('click', () => {
      const open = filterSide.classList.toggle('open');
      filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  $$('[data-filter-group-toggle]').forEach(head => head.addEventListener('click', () => {
    const group = head.closest('.filter-group');
    if (!group) return;
    const open = group.classList.toggle('open');
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  }));

  /* ---------- Research page: article filter pills + modal ---------- */
  const articleTints = {
    emerald: 'rgba(31,138,91,0.25)',
    teal: 'rgba(22,163,154,0.25)',
    amber: 'rgba(208,161,74,0.2)',
    pearl: 'rgba(230,225,210,0.15)',
    rose: 'rgba(201,122,130,0.2)'
  };
  function paintArticleCover(el, tint) {
    if (!el) return;
    const t = articleTints[tint] || articleTints.emerald;
    el.style.background = 'radial-gradient(60% 60% at 40% 30%, ' + t + ', transparent 70%), linear-gradient(180deg, #131313, #050505)';
  }
  $$('[data-article-cover]').forEach(c => paintArticleCover(c, c.getAttribute('data-tint')));

  $$('[data-article-filter]').forEach(btn => btn.addEventListener('click', () => {
    const cat = btn.getAttribute('data-article-filter');
    $$('[data-article-filter]').forEach(b => b.classList.toggle('active', b === btn));
    const featured = $('[data-article-featured]');
    if (featured) featured.style.display = (cat === 'All') ? '' : 'none';
    let shown = 0;
    $$('[data-article-card]').forEach(card => {
      if (card.closest('[data-article-featured]')) return;
      const match = cat === 'All' || card.getAttribute('data-article-cat') === cat;
      card.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    const empty = $('[data-article-empty]');
    if (empty) {
      empty.hidden = shown !== 0;
      empty.textContent = shown === 0 ? 'No articles in "' + cat + '". Try another category.' : '';
    }
  }));

  // Featured-article CTA also opens the modal
  $$('[data-article-featured-cta]').forEach(btn => btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const card = btn.closest('[data-article-card]');
    if (card) openArticleModal(card);
  }));

  // Save to Reading List — fires toast (no real persistence)
  $$('[data-article-save]').forEach(btn => btn.addEventListener('click', () => {
    closeOverlay(articleModal, articleScrim);
    notify('Saved to reading list');
  }));

  const articleModal = $('[data-article-modal]');
  const articleScrim = $('[data-article-scrim]');
  function openArticleModal(card) {
    if (!articleModal) return;
    const tint = card.getAttribute('data-article-tint');
    paintArticleCover($('[data-article-modal-cover]'), tint);
    $('[data-article-modal-cat]').textContent = card.getAttribute('data-article-cat') || '';
    $('[data-article-modal-title]').textContent = (card.querySelector('[data-article-title]') || {}).textContent || '';
    $('[data-article-modal-meta]').textContent = (card.querySelector('[data-article-meta]') || {}).textContent || '';
    $('[data-article-modal-excerpt]').textContent = (card.querySelector('[data-article-excerpt]') || {}).textContent || '';
    openOverlay(articleModal, articleScrim);
  }
  $$('[data-article-card]').forEach(c => c.addEventListener('click', () => openArticleModal(c)));
  $$('[data-article-modal-close]').forEach(b => b.addEventListener('click', () => closeOverlay(articleModal, articleScrim)));
  if (articleScrim) articleScrim.addEventListener('click', () => closeOverlay(articleModal, articleScrim));

  /* ---------- COA Archive: viewer modal ---------- */
  const coaViewer = $('[data-coa-viewer]');
  const coaScrim = $('[data-coa-scrim]');
  function openCoa(card) {
    if (!coaViewer) return;
    const img = $('[data-coa-img]');
    const url = card.getAttribute('data-coa-image');
    if (img) img.src = url;
    $('[data-coa-eyebrow]').textContent = (card.getAttribute('data-coa-task') || '') + ' · ' + (card.getAttribute('data-coa-analyzed') || '');
    $('[data-coa-title-large]').textContent = card.getAttribute('data-coa-title') || '';
    $('[data-coa-sample-large]').textContent = card.getAttribute('data-coa-sample') || '';

    const rows = $('[data-coa-meta-rows]');
    if (rows) {
      const purity = card.getAttribute('data-coa-purity');
      rows.innerHTML =
        '<div class="coa-meta-row"><span>Mass</span><span class="v">' + escapeHtml(card.getAttribute('data-coa-mass') || '') + '</span></div>' +
        (purity ? '<div class="coa-meta-row"><span>Purity</span><span class="v" style="color:#5dc593">' + escapeHtml(purity) + '</span></div>' : '') +
        '<div class="coa-meta-row"><span>Analyst</span><span class="v">Janoshik Analytical</span></div>' +
        '<div class="coa-meta-row"><span>Method</span><span class="v">RP-HPLC / ESI-MS</span></div>' +
        '<div class="coa-meta-row"><span>Verify Key</span><span class="v" style="font-family:var(--mono)">' + escapeHtml(card.getAttribute('data-coa-key') || '') + '</span></div>';
    }
    const link = $('[data-coa-verify-link]');
    if (link) link.href = card.getAttribute('data-coa-verify-url') || 'https://www.janoshik.com/verify/';
    openOverlay(coaViewer, coaScrim);
  }
  $$('[data-coa-card]').forEach(c => c.addEventListener('click', (e) => {
    // Allow inner button to still trigger via delegation
    openCoa(c);
  }));
  $$('[data-coa-close]').forEach(b => b.addEventListener('click', (e) => { e.stopPropagation(); closeOverlay(coaViewer, coaScrim); }));
  if (coaScrim) coaScrim.addEventListener('click', () => closeOverlay(coaViewer, coaScrim));

  /* ---------- FAQ: category switch + search ---------- */
  const faqSearch = $('[data-faq-search]');
  const faqCats   = $$('[data-faq-cat]');
  const faqHeading = $('[data-faq-current-heading]');
  const faqEmpty = $('[data-faq-empty]');
  let faqActiveCat = (faqCats[0] && faqCats[0].getAttribute('data-faq-cat')) || '';

  function applyFaq() {
    const q = faqSearch ? faqSearch.value.trim().toLowerCase() : '';
    let shown = 0;
    $$('[data-faq-item]').forEach(it => {
      const cat = it.getAttribute('data-faq-item-cat');
      const text = (it.getAttribute('data-faq-text') || '').toLowerCase();
      const matchCat = cat === faqActiveCat;
      const matchQ = !q || text.includes(q);
      const show = matchCat && matchQ;
      it.style.display = show ? '' : 'none';
      if (show) shown++;
    });
    if (faqHeading) faqHeading.textContent = faqActiveCat;
    if (faqEmpty) {
      if (shown === 0) {
        faqEmpty.hidden = false;
        faqEmpty.textContent = q ? 'No matches for "' + q + '". Try a broader term.' : 'No questions in this category yet.';
      } else {
        faqEmpty.hidden = true;
      }
    }
  }
  faqCats.forEach(el => el.addEventListener('click', () => {
    faqCats.forEach(x => x.classList.toggle('active', x === el));
    faqActiveCat = el.getAttribute('data-faq-cat') || '';
    applyFaq();
  }));
  if (faqSearch) faqSearch.addEventListener('input', applyFaq);
  if (faqCats.length) applyFaq();

  /* ---------- Support: copy email ---------- */
  $$('[data-copy-email]').forEach(btn => btn.addEventListener('click', async () => {
    const email = btn.getAttribute('data-copy-email');
    if (!email) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(email);
      } else {
        const ta = document.createElement('textarea');
        ta.value = email; ta.setAttribute('readonly','');
        ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      const label = btn.querySelector('[data-copy-label]');
      const state = btn.querySelector('[data-copy-state]');
      if (label) {
        const original = label.textContent;
        label.textContent = 'Copied';
        if (state) state.style.color = '#5dc593';
        setTimeout(() => {
          label.textContent = original;
          if (state) state.style.color = '';
        }, 1800);
      }
      notify('Email copied to clipboard');
    } catch (e) { notify('Could not copy — please copy manually'); }
  }));

  /* ---------- Helpers ---------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
  }
  function parsePriceCentsFromText(text) {
    const m = String(text).match(/[\d,.]+/);
    if (!m) return 0;
    return Math.round(parseFloat(m[0].replace(/,/g, '')) * 100);
  }
  function formatMoney(cents) {
    const fmt = theme.moneyFormat || '${{amount}}';
    const v = (cents / 100);
    const opts = { minimumFractionDigits: (v % 1 === 0 ? 0 : 2), maximumFractionDigits: 2 };
    const str = v.toLocaleString(undefined, opts);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, str)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, v.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, str);
  }
})();
